
import React, { useEffect, useState } from "react";
import { useSubheader } from "@metronic/layout";
import {
  Alert,
  Col,
  Row,
  Card,
  Accordion,
  Button,
  Form,
} from "react-bootstrap";
import {Redirect, useHistory} from "react-router-dom";
import axios from "axios";
import { InssuredData } from "@components/panels/insured-data/inssured-data";
import { HospitalData } from "@components/panels/hospital-data/hospital-data";
import { Documentation } from "@components/panels/documentation/documentation";
import { Binnacle } from "@components/panels/binnacle/binnacle";
import { CostControlData } from "@components/panels/cost-control-data/cost-control-data";
import { SufferingData } from "@components/panels/suffering-data/suffering-data";
import AuthLetters from "@components/panels/auth-letter/auth-letters";
import {
  getBySlug,
  update,
} from "@services/hospitalization";
import { getLasMcMovementtByCase } from "@services/mc-movements";
import { getLastLetterMovByCase } from "@services/letter-movements";
import { isEmpty } from "@utils/check-object-empty";
import moment from "moment";
import { ContentMedicAssignationTrakingMedic } from "@components/panels/medic-assignation-tracking/medic-assignation-tracking-medic";
import { IfHasRole } from "@metronic/_helpers";
import { MedicalFees } from "@components/panels/medical-fee/medical-fees";
import CaseHeader from "@components/panels/case-header/case-header";
import BlockCaseContext from "@contexts/block-case-context";
import { useCommentValidation } from "@contexts/comment-validation-context";
import WithCommentValidation from "@components/shared/with-comment-validation";
import $ from "jquery";
import {isCaseInCorrectModule} from "@utils/check-module-status";
import {CASE_STATUS} from "@constants/case-statuses";
import { useAutomaticCommentSave } from "@hooks/use-automatic-comment-save";
import { getMexicoTimestamp } from "@utils/date-utils";

const CostControlDetails = (props) => {
  const [caseRecord, setCaseRecord] = useState({});
  const [mcMovement, setMcMovement] = useState({});
  const [letterMov, setLetterMov] = useState({});
  const [totalLetters, setTotalLetters] = useState(0);
  const [shouldBlockCase, setShouldBlockCase] = useState(true);


  const subheader = useSubheader();
  const { validateCommentRequired } = useCommentValidation();
  const { saveCommentAutomatically } = useAutomaticCommentSave({ caseData: caseRecord });
  const { saveCommentAutomaticallyUnam } = useAutomaticCommentSave({
    caseData: caseRecord,
    eventStage: null,
    comment: "FAVOR DE FACTURAR A UNAM, DE NO HACERLO NO SE PODRÁ PAGAR",
    isPageable: false,
    hideReason: true,
  });

  const { slug } = props.match.params;

  useEffect(() => {
    getBySlug(slug).then((response) => {
      setCaseRecord(response.data);
      getLasMcMovementtByCase(response.data.id).then((currentMcMovemet) =>
        setMcMovement(currentMcMovemet.data)
      );
      getLastLetterMovByCase(response.data.id).then((currrentLetterMov) =>
        setLetterMov(currrentLetterMov.data)
      );
    });

    subheader.setTitle("Control de Costos");
  }, []);

  let history = useHistory();

  let submitFormCostControlData = null;
  let submitFormCostControlDataErrors = null;

  const query = new URLSearchParams(props.location.search);

  const bindSubmitFormCostControlData = (submitForm) =>
    (submitFormCostControlData = submitForm);

  const bindSubmitFormCostControlDataErrors = (errors) =>
    (submitFormCostControlDataErrors = errors);

  let submitFormMedicAssignation = null;
  let submitFormMedicAssignationErrors = null;

  const bindSubmitFormMedicAssignation = (submitForm) =>
    (submitFormMedicAssignation = submitForm);

  const bindSubmitFormMedicAssignationErrors = (errors) =>
    (submitFormMedicAssignationErrors = errors);

  const onClickSendDictum = async () => {
    await submitFormCostControlData();
    if (submitFormMedicAssignation !== null) {
      await submitFormMedicAssignation();
    }

    if (isEmpty(submitFormCostControlDataErrors) && isEmpty(submitFormMedicAssignationErrors)) {
      let inputReasonDictum = document.getElementById("reason_sendToDictum").value;
      if (inputReasonDictum === "") {
        alert("Debe seleccionar una razon");
        return;
      }
      if (!validateCommentRequired()) {
        return;
      }
      $("#btn_save_comment").click();

      update({ caseStatusId: 5, dictumReason: inputReasonDictum, feadictamen: getMexicoTimestamp()},
        caseRecord.id
        ).then((response) => {
        history.push("/control_costos");
      });
    }
  }

  const onClickSendControlDesk = async () => {
    await submitFormCostControlData();
    if (submitFormMedicAssignation !== null) {
      await submitFormMedicAssignation();
    }

    if (isEmpty(submitFormCostControlDataErrors) && isEmpty(submitFormMedicAssignationErrors)) {
      if (!validateCommentRequired()) {
        return;
      }
      $("#btn_save_comment").click();
      update({ caseStatusId: 2},
          caseRecord.id
      ).then((response) => {
        history.push("/control_costos");
      });
    }
  }

  const onClickPatientStore = async () => {
    await submitFormCostControlData();

    if (submitFormMedicAssignation !== null) {
      await submitFormMedicAssignation();
    }

    if (isEmpty(submitFormCostControlDataErrors) && isEmpty(submitFormMedicAssignationErrors)) {
      if (!validateCommentRequired()) {
        return;
      }
      await saveCommentAutomatically();
      await saveCommentAutomaticallyUnam();
      let timestamp = getMexicoTimestamp();
      update(
        { caseStatusId: 7, feaapaciente: timestamp},
        caseRecord.id
        ).then((response) => {
        history.push("/control_costos");
      });
    }
  }

  const onClickSendMedicInformation = async () => {
    if (!validateCommentRequired()) {
      return;
    }
    await saveCommentAutomatically();
    await saveCommentAutomaticallyUnam();
    let timestamp = getMexicoTimestamp();
    update({ caseStatusId: 4, feaimedica: timestamp }, caseRecord.id)
      .then((response) => {
        history.push("/dictamen_medico");
      });
  }

  const onClickSendHospitalSupervision = async () => {
    const inputReasonHospitalSupervision = document.getElementById("reason_sendToHospitalSupervision").value;
    if (inputReasonHospitalSupervision === "") {
      alert("Debe seleccionar una razon");
      return;
    }

    await submitFormCostControlData();

    if (submitFormMedicAssignation !== null) {
      await submitFormMedicAssignation();
    }

    if (isEmpty(submitFormCostControlDataErrors) && isEmpty(submitFormMedicAssignationErrors)) {
      if (!validateCommentRequired()) {
        return;
      }

      await saveCommentAutomatically();
      await saveCommentAutomaticallyUnam();

      let timestamp = getMexicoTimestamp();
      update({
        caseStatusId: CASE_STATUS.HOSPITAL_SUPERVISION,
        reasonHospitalSupervision: inputReasonHospitalSupervision,
      }, caseRecord.id)
        .then((response) => {
          history.push("/supervision_hospitalaria");
        });
    }
  }

  if (!isCaseInCorrectModule(caseRecord, [CASE_STATUS.COST_CONTROL])) {
    return <Redirect to="/error/unauthorized"/>;
  }

  return (
    <>
      <Alert
        variant="success"
        className="text-center"
        style={{ fontSize: "16px" }}
      >
        Control de Costos
      </Alert>

      <CaseHeader caseRecord={caseRecord} enableHospitalSupervisionStatus={true} showSpecialities={true} />

      <BlockCaseContext.Provider value={[shouldBlockCase, setShouldBlockCase]}>
      <Accordion defaultActiveKey={query.has("from") && query.get("from") === "control_board" ? "" : "0"} className="mt-5">
        <InssuredData
          icon="fa-search"
          eventKey="1"
          data={caseRecord}
          disabledAll={true}
          bindSubmitForm={()=>{}}
        />
        <HospitalData
          icon="fa-search"
          eventKey="2"
          data={caseRecord}
          disabledAll={true}
          bindSubmitForm={()=>{}}
        />
        { (IfHasRole("Admin") || IfHasRole("ADMINAXA") || IfHasRole("ADMIN_REGION_CELULA") || IfHasRole("DICTAMEN-CONTLCOSTOS") ) && <ContentMedicAssignationTrakingMedic
          icon="fa-pencil-alt"
          eventKey="0"
          data={caseRecord}
          mcMovement={letterMov}
          disabledAll={query.has("from") && query.get("from") === "control_board"}
          bindSubmitForm={bindSubmitFormMedicAssignation}
          bindErrors={bindSubmitFormMedicAssignationErrors}
        /> }
        <CostControlData
          icon="fa-pencil-alt"
          eventKey="0"
          data={caseRecord}
          mcMovement={mcMovement}
          letterMov={letterMov}
          totalLetters={totalLetters}
          disabledAll={query.has("from") && query.get("from") === "control_board"}
          showForm={true}
          bindSubmitForm={bindSubmitFormCostControlData}
          bindErrors={bindSubmitFormCostControlDataErrors}
          totalDeviations={caseRecord.hospital?.atc?.toLowerCase() === 'no'}
        />
        <SufferingData
          icon="fa-pencil-alt"
          eventKey="7"
          data={caseRecord}
          disabledAll={false}
          bindSubmitForm={() => {}}
        />
        <AuthLetters
          icon="fa-search"
          showForm={false}
          hideDeleteOption={true}
          eventKey="3"
          data={caseRecord}
          disabledAll={false}
          setTotalLetters={setTotalLetters}
          {...props}
        />
        <Documentation
          icon ="fa-search"
          eventKey="4"
          data={caseRecord}
          disabledAll={query.has("from") && query.get("from") === "control_board"}
          typesDocument={[
            "Aviso de Accidente", "Carta de Autorización", "Comprobante de seguro o poliza", "Denuncia ante MP",
            "Estudios de Gabinete", "Estudios de Laboratorio", "Estudios que Confirmen DX", "Historia Clinica",
            "Honorarios Médicos", "Identificacion", "Informe Medico Actualizado", "Nota de Evolución",
            "Nota Postquirurgica", "Resumen Medico Actualizado", "Visado Final", "Nota de Remisión", "Sabana Quirurgica", "Otro",
          ]}
          {...props}
        />
        <MedicalFees
          icon= "fa-search"
          icone="fa-pencil-alt"
          eventKey="5"
          data={caseRecord}
          hideBtnInsurance={false}
          hideFormCreate={true}
          showForm={!query.has("from") && query.get("from") !== "control_board"}
          ableToHideAuthLetters={true}
          {...props}
        />
      </Accordion>
      <Accordion defaultActiveKey="5" className="mt-5">
        <Binnacle
          icon="fa-pencil-alt"
          eventKey="5"
          data={caseRecord}
          disabledAll={false}
          eventStage="Control de Costos"
          {...props}
        />
      </Accordion>
      </BlockCaseContext.Provider>

      <Row hidden={query.has("from") && query.get("from") === "control_board"}>
        {caseRecord.caseType === "Revision de corte" &&
        <Col className="mt-5">
          <Button variant="warning" onClick={onClickSendMedicInformation}>
            Enviar a Informacion Médica Hospital
          </Button>
        </Col>}

        <Col className="mt-5">
          <Button variant="danger" onClick={onClickSendDictum}>
            Enviar a Dictamen
          </Button>

          <Form.Control
            className="mt-5 mr-3"
            as="select"
            name="reason_sendToDictum"
            id="reason_sendToDictum"
          >
            <option value="">Selecciona una opcion...</option>
            <option value="Carta Erronea">Carta Erronea</option>
            <option value="Monto en Carta Insuficiente">Monto en Carta Insuficiente</option>
          </Form.Control>
        </Col>

        <Col className="mt-5">
          <Button variant="danger" onClick={onClickSendControlDesk}>
            Enviar a Mesa de Control
          </Button>
        </Col>

        {caseRecord.caseType !== "Revision de corte" &&
        <Col>
          <Button
            className="mt-5"
            variant="success"
            onClick={onClickPatientStore}
          >
            Enviar a Alta Paciente
          </Button>
        </Col>}

        <Col className="mt-5 mr-5">
          <Button variant="danger" onClick={onClickSendHospitalSupervision}>
            Enviar a Supervisión Hospitalaria
          </Button>

          <Form.Control
            className="mt-5 mr-3"
            as="select"
            name="reason_sendToHospitalSupervision"
            id="reason_sendToHospitalSupervision"
          >
            <option value="">Selecciona una opcion...</option>
            <option value="Sobreutilización">Sobreutilización</option>
            <option value="Sobrecosto">Sobrecosto</option>
            <option value="Aclaración">Aclaración</option>
            <option value="Caso Inicial">Caso Inicial</option>
            <option value="Falta de Informacion">Falta de Informacion</option>
          </Form.Control>
        </Col>
      </Row>
    </>
  );
};

export default WithCommentValidation(CostControlDetails);

